import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/common/scrollToTop/ScrollToTop";
import Header from "./components/common/Header/Header";
import Footer from "./components/common/Footer/Footer";
import Home from "./components/pages/home/Home";
// import { Contact } from "./components/pages/contact/Contact";
import CookieConsent from "./components/common/cookies/CookiesConsent";
import PrivacyPolicy from "./components/common/PrivacyPolicy";

import { InvestorForm } from "./components/common/investorForm/InvestorForm";

// import axios from "axios";

function App() {
  return (
    <Router className="App">
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/investor" element={<InvestorForm />} />
      </Routes>
      <CookieConsent />
      <Footer />
    </Router>
  );
}

export default App;
